module.exports = __webpack_public_path__ + "img/star.65760068.png";